import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-arrow\"><defs><style>#icon-arrow .a{fill:currentColor;}#icon-arrow .b{fill:none;}</style></defs><g transform=\"translate(-876 -314)\"><path class=\"a\" d=\"M259.727,261,256,264.727,257.273,266l5-5-5-5L256,257.273Zm5.455,0-3.727,3.727L262.727,266l5-5-4.909-5-1.364,1.273Z\" transform=\"translate(621.136 60)\" /><rect class=\"b\" width=\"14\" height=\"14\" transform=\"translate(876 314)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol